// import React, { Component } from "react";

import { message } from "antd";
// import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
// import { useSelector, useDispatch } from "react-redux";


function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
//   const lang_choiced = useSelector((state) => state.lang_change);
    
  
//   const dispatch = useDispatch();
  function beforeUpload(file) {
    
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("لطفا فقط از فرمت های JPG/PNG استفاده کنید!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("حجم عکس انتخابی شما باید کمتر از 5 مگابایت باشد!");
    }
    return isJpgOrPng && isLt2M;
  }


  export {getBase64 , beforeUpload}